import { render } from "./ListaOpcoes.vue?vue&type=template&id=e0ce51b6&scoped=true&ts=true"
import script from "./ListaOpcoes.vue?vue&type=script&lang=ts"
export * from "./ListaOpcoes.vue?vue&type=script&lang=ts"

import "./ListaOpcoes.vue?vue&type=style&index=0&id=e0ce51b6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0ce51b6"]])

export default __exports__